import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { TERMS_CHECKBOX_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.label`
    ${TERMS_CHECKBOX_RESET}

    display: flex;
    align-items: center;
    gap: ${SPACING.size8};
    cursor: pointer;
    position: relative;
    flex-direction: column;
    align-items: start;

    &:focus-visible {
      outline: 2px solid ${COLORS['info-500']};
      outline-offset: 4px;
    }
  `,

  CheckboxWrapper: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size16};
  `,

  // Visually hide the actual checkbox but keep it accessible
  HiddenCheckbox: styled.input<{ $checked: boolean }>`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:focus + div {
      border: 1px solid
        ${(props) => (props.$checked ? COLORS['charcoal-500'] : COLORS['pebble-400'])};
    }
  `,

  CustomCheckbox: styled.div<{ $checked: boolean }>`
    min-width: 18px;
    min-height: 18px;
    border-radius: 4px;
    border: 1px solid ${(props) => (props.$checked ? COLORS['charcoal-500'] : COLORS['pebble-400'])};
    background-color: ${(props) => (props.$checked ? COLORS['charcoal-500'] : COLORS['white-50'])};
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      outline: 2px solid ${COLORS['charcoal-alpha-50']};
    }
  `,

  Label: styled.span`
    ${TYPOGRAPHY.labelMediumRegular}
  `,

  ErrorWrapper: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    height: 16px;
  `,

  ErrorText: styled.span`
    ${TYPOGRAPHY.labelSmallRegular}
    color: ${COLORS['danger-500']};
  `
};
